module.exports = __webpack_public_path__ + "static/media/logo-smartasn.6e0c26d4.svg";